import cookie from "js-cookie";
import type { CookieAttributes as CookieOptions } from "js-cookie";

import { IStorage, ICookieManager } from "@src/interfaces";

const clientCookie = (cookieProvider: ICookieManager = cookie): IStorage => ({
	read: (cookieName) => cookieProvider.get()[cookieName],
	write: (cookieName, value, options?: CookieOptions) => {
		cookieProvider.set(cookieName, value, options);
	},
	remove: (cookieName) => {
		cookieProvider.remove(cookieName);
	},
});

export type ClientSideStorage = {
	default: typeof clientCookie;
};

export default clientCookie;
